/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Remove a directory entry.
*
* @module @stdlib/fs-unlink
*
* @example
* var unlink = require( '@stdlib/fs-unlink' );
*
* function done( error ) {
*     if ( error ) {
*         throw error;
*     }
* }
*
* unlink( './beep/boop.txt', done );
*
* @example
* var unlinkSync = require( '@stdlib/fs-unlink' ).sync;
*
* var err = unlinkSync( './beep/boop.txt' );
* if ( err instanceof Error ) {
*     throw err;
* }
*/

// MODULES //

var setReadOnly = require( '@stdlib/utils-define-nonenumerable-read-only-property' );
var main = require( './main.js' );
var sync = require( './sync.js' );


// MAIN //

setReadOnly( main, 'sync', sync );


// EXPORTS //

module.exports = main;
